import { Component, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { StateManagerProjectService } from '@state-manager';
import { IClaimantDetailsDto } from '@viewer/services/project-actions.data';

@Component({
  selector: 'app-info-panel-about-claimant-user',
  templateUrl: 'info-panel-about-claimant-user.component.html',
  styleUrls: ['info-panel-about-claimant-user.component.scss'],
})
export class InfoPanelAboutClaimantUserComponent implements OnDestroy {
  public claimantFirstName: string;
  public claimantLastName: string;

  private _unsubscribe$ = new Subject<void>();

  constructor(public stateProjectManagerService: StateManagerProjectService) {
    this.stateProjectManagerService.claimantUser$
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((value: IClaimantDetailsDto | undefined) => {
        this.claimantFirstName = value ? value.claimantFirstName : '';
        this.claimantLastName = value ? value.claimantLastName : '';
      });
  }

  closePanel(): void {
    this.stateProjectManagerService.isPanelForClaimantUserVisible = false;
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next(undefined);
    this._unsubscribe$.complete();
  }
}
